'use client';

import {
    CityCuratorArchaeologyDetailFrame,
    CityCuratorArchaeologyIntroFrame,
    CityCuratorArchaeologyScrollSnapFrame
} from "@/app/features/sites/city-curator-archaeology/ui/shared/CityCuratorArchaeologyFrames";
import SlideshowIntroV2 from "@/app/__to_be_integrated/_____components/_NEW/intros/slideshow/SlideshowIntroV2";
import { notNull } from "@/app/lib/common/not-null";
import { Divider } from "@mui/material";
import RelatedInfosView from "@/app/features/shared/related-infos/ui/RelatedInfos.public";
import {
    useSiteCityCuratorArchaeologyEditor
} from "@/app/features/sites/city-curator-archaeology/contexts/CityCuratorArchaeologyEditorContext";
import { DetailSectionEditable } from "@/app/features/shared/detail-section";
import { DetailEditable } from "@/app/features/shared/types/types";

export default function CityCuratorArchaeologyEditable() {

    const { editable, updateEditable } = useSiteCityCuratorArchaeologyEditor();

    const detailImages = editable?.details
        .filter(notNull)
        .filter((detail) => !!detail.image)
        .map((detail) => detail.image!)
        .filter(notNull) || []


    function updateDetailByIndex(indexToUpdate: number, partialDetail: Partial<DetailEditable>) {
        updateEditable({
            details: editable?.details.filter(notNull).map((detail, index) => {
                return index === indexToUpdate
                    ? { ...detail, ...partialDetail }
                    : detail

            })
        })
    }

    return (
        <CityCuratorArchaeologyScrollSnapFrame>
            <CityCuratorArchaeologyIntroFrame>
                <SlideshowIntroV2
                    title={editable?.title || ''}
                    images={detailImages}
                    subtitle={editable?.subtitle || ''}
                />
            </CityCuratorArchaeologyIntroFrame>

            {editable?.details.filter(notNull).map((detail, index) => (
                <span key={index}>
                    <Divider sx={{ m: 4 }} />
                    <CityCuratorArchaeologyDetailFrame>
                        <DetailSectionEditable
                            data={detail}
                            alignment={index % 2 === 0 ? "row" : "row-reverse"}
                            onTitleChange={(title) => updateDetailByIndex(index, { title })}
                            onSubtitleChange={(subtitle) => updateDetailByIndex(index, { subtitle })}
                            onDescriptionChange={(description) => updateDetailByIndex(index, { description })}
                            onImageChange={(image) => updateDetailByIndex(index, { image })}
                        />
                    </CityCuratorArchaeologyDetailFrame>
                </span>
            ))}

             <RelatedInfosView relatedInfos={editable?.relatedInfos.filter(notNull) || []} />

        </CityCuratorArchaeologyScrollSnapFrame>
    )
}
